import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["date", "display"];

  connect() {
    this.updateDisplayInput();
  }

  updateDisplayInput() {
    const dateValue = this.dateTarget.value;
    if (dateValue) {
      this.displayTarget.value = this.formatDate(dateValue);
    }
  }

  updateHiddenInput() {
    const dateValue = this.dateTarget.value;
    if (dateValue) {
      this.displayTarget.value = this.formatDate(dateValue);
    }
  }

  openDatepicker() {
    window.dateTarget = this.dateTarget;
    this.dateTarget.showPicker();
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const lang = document.documentElement.lang || "nl";

    const replacements = {
      "DD": date.toLocaleString(lang, { weekday: "long" }),
      "dd": String(date.getDate()).padStart(2, "0"),
      "d": String(date.getDate()),
      "MM": date.toLocaleString(lang, { month: "long" }),
      "M": date.toLocaleString(lang, { month: "short" }),
      "mm": String(date.getMonth() + 1).padStart(2, "0"),
      "yyyy": date.getFullYear(),
      "yy": String(date.getFullYear()).slice(-2)
    };

    return (this.displayTarget.dataset.format || "dd MM yyyy").replace(
      /\b(DD|dd|d|MM|M|mm|yyyy|yy)\b/g,
      match => replacements[match] || match
    );
  }
}
